<template>
    <div class="topo-radio" @input="updateValue">
        <div
            v-for="option in options"
            :key="option.value"
            class="topo-radio__option"
            :class="{ 'topo-radio__option--selected': option.value === selected }"
            @click="updateValue(option)"
        >
            {{ option.label }}
        </div>
    </div>
</template>

<script>
export default
{
    name: 'TopoRadio',

    components:
    {
    },

    props:
    {
        modelValue:
        {
            type:    [String, Number, null],
            default: null,
        },
        options:
        {
            type:     Array,
            required: true,
        },
    },

    emits:
    [
        'update:modelValue',
    ],

    data()
    {
        return {
            selected: null,
        };
    },

    computed:
    {
    },

    watch:
    {
        modelValue()
        {
            this.selected = this.modelValue;
        },
    },

    created()
    {
        this.selected = this.modelValue;
    },

    methods:
    {
        updateValue(option)
        {
            this.selected = (this.selected === option.value ? null : option.value);

            this.$emit('update:modelValue', this.selected);
        },
    },
};
</script>
